import React from 'react';

const DatePickerLoader = React.forwardRef<HTMLDivElement, any>((props, ref) => {
	return <div className="date-picker-alt" ref={ref}>
		<div className="react-datepicker-wrapper">
			<div className="react-datepicker__input-container">
				<input className="ant-input" value="" placeholder={props.placeholder} style={{ pointerEvents: 'none' }} />
			</div>
		</div>
		<i className="fa fa-calendar-o anticon-calendar" aria-hidden="true" />
	</div>;
});

export default DatePickerLoader;
